import { Column, Columns } from '@vtex/admin-ui'
import {
  Accumulate,
  AccumulateManualPrices,
  Accumulations,
  AdditionalInformation,
  BIN,
  Budget,
  Cluster,
  Conditions,
  MaxItemsPerAttribute,
  MaxItemsPerCart,
  MaxUsage,
  MaxUsagePerClient,
  Origin,
  PaymentMethods,
  PromotionHighlight,
  Restrictions,
  SalesChannels,
  Sellers,
  ShippingLocation,
  Storefront,
  UTM,
} from 'ui'
import { GeneralInformation } from '../../GeneralInformation'
import { StackedBoxes } from '../../StackedBoxes'
import { ProgressiveDiscountEffect } from './ProgressiveDiscountEffect'

export default function ProgressiveDiscountForm() {
  return (
    <Columns space="$space-20">
      <Column units={7}>
        <GeneralInformation />
        <ProgressiveDiscountEffect name="progressive" />
        <Conditions>
          <BIN name="conditions.bin" />
          <Cluster name="conditions.cluster" />
          <ShippingLocation name="conditions.shippingLocation" />
          <PaymentMethods name="conditions.paymentMethods" />
          <UTM name="conditions.utm" />
        </Conditions>
        <Restrictions>
          <MaxUsage name="restrictions.maxUsage" />
          <MaxUsagePerClient name="restrictions.maxUsagePerClient" />
          <MaxItemsPerCart name="restrictions.maxItemsPerCart" />
        </Restrictions>
        <Accumulations>
          <AccumulateManualPrices name="restrictions.accumulateWithManualPrices" />
        </Accumulations>
        <Storefront>
          <PromotionHighlight name="storefront.highlight" />
          <AdditionalInformation name="storefront.additionalInformation" />
        </Storefront>
      </Column>
      <Column>
        <StackedBoxes>
          <Origin name="restrictions.origin" />
          <SalesChannels name="restrictions.salesChannels" />
          <Budget name="restrictions.budget" />
          <Sellers name="restrictions.sellers" />
        </StackedBoxes>
      </Column>
    </Columns>
  )
}
